import {createMetaManager} from 'vue-meta'

const vueMeta = createMetaManager(false)

export default vueMeta
